import Swal from 'sweetalert2';
import Fetch from '../../utils/fetch';
import { settings } from '../../settings';

export async function sendPasswordResetLink(
  userEmail: string
): Promise<boolean> {
  const confirmResult = await Swal.fire({
    title: 'Confirm reset password',
    text: `Please confirm to send a password reset email to ${userEmail}!`,
    icon: 'warning',
    showCancelButton: true,
    focusCancel: true,
  });
  if (confirmResult.isConfirmed) {
    const sendResult = await Fetch.post({
      url: `${settings.newApiUrl}/user/reset-password`,
      body: {
        email: userEmail,
      },
    });
    if (sendResult.ok) {
      return true;
    } else {
      await Swal.fire({
        title: 'Error',
        text: 'Could not trigger sending a password reset link!',
        icon: 'error',
      });
    }
    return false;
  }
}
